import type { KeyboardEvent } from 'react'

/**
 * Keyboard half of a clickable surface that cannot be a real <button>, such
 * as a card or row that holds its own nested buttons or block content. Pair
 * it with role="button" and tabIndex={0}:
 *
 *   <div role="button" tabIndex={0} onClick={open} onKeyDown={activateOnKey(open)}>
 *
 * Enter and Space run the handler, as they would on a native button. Keys
 * pressed inside a nested control (a field, a menu trigger) belong to that
 * control, so only presses on the surface itself activate it.
 */
export function activateOnKey<E extends Element = HTMLElement>(
  handler: (event: KeyboardEvent<E>) => void,
) {
  return (event: KeyboardEvent<E>) => {
    if (event.target !== event.currentTarget) return
    if (event.key !== 'Enter' && event.key !== ' ') return
    event.preventDefault()
    handler(event)
  }
}
